import React from 'react';
import { cn } from './cn';

export default function FormField({
  label,
  htmlFor,
  error,
  hint,
  required,
  className,
  children,
}) {
  return (
    <div className={cn('space-y-1.5', className)}>
      {label && (
        <label
          htmlFor={htmlFor}
          className="block text-sm font-medium text-ga-text-primary"
        >
          {label}
          {required && <span className="text-ga-danger ml-0.5">*</span>}
        </label>
      )}
      {children}
      {error && <p className="text-xs text-ga-danger">{error}</p>}
      {!error && hint && <p className="text-xs text-ga-text-subtle">{hint}</p>}
    </div>
  );
}
